import { Controller } from 'react-hook-form';

import { Checkbox as AntdCheckbox, type CheckboxProps } from 'antd';

const Checkbox = ({ id, name, children, ...props }: CheckboxProps) => {
  return (
    <Controller
      render={({ field: { value, ...field } }) => (
        <AntdCheckbox id={id} {...props} checked={value} {...field}>
          {children}
        </AntdCheckbox>
      )}
      name={name || ''}
    />
  );
};

export default Checkbox;
